import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'

const mapStateToProps = (state) => {
    const activeGroup = state.getIn(['ui', 'groupStack', 'activeGroup'])
    const groupCollection = state.getIn(['ui', 'entityStack', 'groups', 'groups'])

    const groupIndex = groupCollection.findIndex((group) => _.toString(group.get('id')) === _.toString(activeGroup))
    const name = groupCollection.get(groupIndex).get('name')

    return { groupName: name }
}

export default (ImportPreloadComponent) => {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        static propTypes = {
            groupName: PropTypes.string.isRequired,
        }

        render() {
            return <ImportPreloadComponent {...this.props} />
        }
    }

    return HocConnect
}
